module.exports = __webpack_public_path__ + "media/images/crypto-currencies/eos-7b4c3701a96e190dd6cac5b8bf0a68e7.svg";